<div class="body-2" [ngStyle]="asignaEstiloBody()">
  <div class="sign-up-wrap smallw">
    <div class="divusr">
      <div class="divizquierdausr ocultarmediumw">
      </div>
      <div class="divfotousr">
        <img [src]="srcLogo" loading="lazy" alt="" class="fotousr">
      </div>
      <div class="divdetalleusr">
        <h4 class="colortituloingreso">Crear un nuevo usuario (llenar todos los datos)</h4>
      </div>
      <div class="divizquierdausr ocultarmediumw">
        <p class="ppegadoabajo">
          <a>.</a>
        </p>
      </div>
    </div>
    <div class="seccionusr wf-section">
      <div class="divusr">
        <div class="divdetalleusr">
          <div class="w-form">
            <form [formGroup]="formNuevoUsr" (ngSubmit)="nuevoUsrSubmit()" #nuevoUsrForm="ngForm" id="nuevoUsr-form"
              name="nuevoUsr-form" data-name="Formulario de nuevoUsr">
              <div class="lineadetusrped ldup60vw">
              </div>
              <p class="ppegadoabajo">
                <a class="colortextoingreso">Nombres completos:</a>
              </p>
              <div class="lineadetusrped">
                <input type="text" formControlName="fTxtCliente" [ngStyle]="asignaEstilo(formNuevoUsr, 'fTxtCliente')"
                  name="fTxtCliente" data-name="fTxtCliente" id="fTxtCliente" required="" placeholder="Nombre"
                  class="text_field w-input" minlength="3" maxlength="256">
              </div>
              <p class="ppegadoabajo">
                <a class="colortextoingreso">Cédula / RUC / Pasaporte:</a>
              </p>
              <div class="lineadetusrped">
                <input type="text" formControlName="fTxtCedula" [ngStyle]="asignaEstilo(formNuevoUsr, 'fTxtCedula')"
                  name="fTxtCedula" data-name="fTxtCedula" id="fTxtCedula" required=""
                  placeholder="Cédula, RUC o Pasaporte" class="text_field w-input" minlength="3" maxlength="256">
              </div>
              <p class="ppegadoabajo">
                <a class="colortextoingreso">Medio preferido de contacto (mail, teléfono, Whatsapp)?</a>
              </p>
              <div class="lineadetusrped">
                <input type="text" formControlName="fTxtContacto" [ngStyle]="asignaEstilo(formNuevoUsr, 'fTxtContacto')"
                  name="fTxtContacto" data-name="fTxtContacto" id="fTxtContacto" required=""
                  placeholder="Mail, teléfono, Whatsapp" class="text_field w-input" minlength="3" maxlength="256">
              </div>
              <p class="ppegadoabajo">
                <a class="colortextoingreso">Teléfonos de contacto:</a>
              </p>
              <div class="lineadetusrped">
                <input type="text" formControlName="fTxtTelfContacto"
                  [ngStyle]="asignaEstilo(formNuevoUsr, 'fTxtTelfContacto')" name="fTxtTelfContacto"
                  data-name="fTxtTelfContacto" id="fTxtTelfContacto" required="" placeholder="Teléfonos de contacto"
                  class="text_field w-input" minlength="3" maxlength="256">
              </div>
              <p class="ppegadoabajo">
                <a class="colortextoingreso">Dirección:</a>
              </p>
              <div class="lineadetusrped">
                <input type="text" formControlName="fTxtDirUsr" [ngStyle]="asignaEstilo(formNuevoUsr, 'fTxtDirUsr')"
                  name="fTxtDirUsr" data-name="fTxtDirUsr" id="fTxtDirUsr" required="" placeholder="Dirección"
                  class="text_field w-input" minlength="3" maxlength="256">
              </div>
              <p class="ppegadoabajo">
                <a class="colortextoingreso">e-mail y password: <small>. . . Password: long >=8, minúsculas, mayúsculas,
                    números y
                    signos</small></a>
              </p>
              <div class="lineadetusrped">
                <input type="email" formControlName="fTxtMail" [ngStyle]="asignaEstilo(formNuevoUsr, 'fTxtMail')"
                  name="fTxtMail" data-name="fTxtMail" id="fTxtMail" required="" placeholder="e-mail"
                  class="text_field w-input" minlength="5" maxlength="256" #spy>
              </div>
              <div class="lineadetusrped">
                <input type="password" formControlName="fTxtPwd" [ngStyle]="asignaEstilo(formNuevoUsr, 'fTxtPwd')"
                  name="fTxtPwd" data-name="fTxtPwd" id="fTxtPwd" required="" placeholder="password"
                  class="text_field w-input" minlength="8" maxlength="256" #pwd>
                <input type="password" formControlName="fTxtPwd2" [ngStyle]="asignaEstilo(formNuevoUsr, 'fTxtPwd2')"
                  name="fTxtPwd2" data-name="fTxtPwd2" id="fTxtPwd2" required="" placeholder="repita el password"
                  class="text_field w-input" minlength="8" maxlength="256" #pwd2>
                <button type="button" class="boton_accion" id="btnTogglePwd" (click)="togglePwd()">
                  Ver password
                </button>
              </div>
              <div class="lineadetusrped">
                <label class="w-checkbox">
                  <input type="checkbox" formControlName="fChkAcepto" name="fChkAcepto" data-name="fChkAcepto"
                    id="fChkAcepto" class="w-checkbox-input">
                  <span class="checkbox-label w-form-label">
                    <p class="colortextoingreso">He leído y acepto los <a routerLink="/sitio-publico/terminos"
                        class="link">Términos de Uso y Política de Privacidad</a>
                    </p>
                  </span>
                </label>
              </div>
              <h4 *ngIf="mensajeRegistro!==''" class="coloralertaingreso">{{mensajeRegistro}}</h4>
              <h4 *ngIf="mensajeRegistro2!==''" class="coloralertaingreso">{{mensajeRegistro2}}</h4>
              <div class="columns-7 w-row">
                <div class="w-col w-col-6">
                  <input type="submit" [disabled]="!formNuevoUsr.valid"
                    [ngStyle]="asignaEstiloSubmitDisabled(formNuevoUsr)" value="Crear Usuario"
                    data-wait="Un momento, por favor..." id="fBtnIngresar" class="button w-button smallw">
                </div>
                <div class="w-col w-col-6">
                  <input type="submit" routerLink="/sitio-publico/inicio" value="Salir"
                    data-wait="Un momento, por favor..." id="fBtnSalir" class="button w-button smallw">
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>